import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'maskCEP'
})
export class MaskCEPPipe implements PipeTransform {
    transform(cep: string) {
        if (cep !== null) {
            return cep.substr(0, 5) + '-' + cep.substr(5, 3);
        }
        return;
    }
}
